var _excluded = ["input", "size", "meta", "onValueChangeCallback", "forceNegative"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import NumericFormat from "../react-number-format/NumericFormat";
import { Field } from "redux-form";
import { numericFormatSmallStyle, numericFormatLargeStyle } from "../mui/material/TextField";
var StyledTextField = styled(TextField)(function (_ref) {
  var size = _ref.size;
  if (size === "small") return numericFormatSmallStyle;else if (size === "large") return numericFormatLargeStyle;else throw new Error("Size not supported.");
});
function NumericFormatTextField(_ref2) {
  var input = _ref2.input,
    size = _ref2.size,
    _ref2$meta = _ref2.meta,
    touched = _ref2$meta.touched,
    invalid = _ref2$meta.invalid,
    error = _ref2$meta.error,
    onValueChangeCallback = _ref2.onValueChangeCallback,
    forceNegative = _ref2.forceNegative,
    custom = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(NumericFormat, _extends({}, custom, {
    name: input.name,
    id: input.id,
    value: input.value,
    customInput: StyledTextField,
    variant: "filled",
    size: size,
    invalid: touched && error !== undefined,
    error: touched && invalid,
    helperText: touched && error,
    onBlur: function onBlur() {
      return input.onBlur();
    }
    // InputProps={{ disableUnderline: true }}
    ,
    onValueChange: function onValueChange(values) {
      var value = forceNegative && values.floatValue !== 0 ? Math.abs(values.floatValue) * -1 : values.floatValue;
      input.onChange(value);
      onValueChangeCallback && onValueChangeCallback(value);
    },
    className: "rounded"
  }));
}
NumericFormatTextField.defaultProps = {
  size: "large"
};
NumericFormatTextField.propTypes = {
  size: PropTypes.string
};
export default (function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: NumericFormatTextField
  }));
});